module.exports = __webpack_public_path__ + "static/media/signUp.d07b5a76.svg";